<template>
  <div id="GrowthPhaseChange">
    <vs-popup id="growthPhaseChangePopup" title="Growth Phase Change" :style="{ 'z-index': zIndex }" :active.sync="isActive">
      <div class="vx-row">
        <div class="mb-2 vx-col w-full grid lg:grid-cols-3 md:grid-cols-2 gap-5">
          <!-- growth phase -->
          <div class="mb-2 w-full">
            <label for="GrowthPhase">New Growth Phase</label>
            <select-2
              autocomplete
              class="w-full"
              v-model="form.plant_stage"
              @input="(item) => (form.plant_stage = item && item.value)"
              v-validate="'required'"
              name="Growth Phase"
              placeholder="Select Growth Phase"
              :options="growthPhaseOptions"
            />
            <span class="text-danger text-sm" v-show="errors.has('Growth Phase')">{{ errors.first('Growth Phase') }}</span>
          </div>

          <!-- location -->
          <div class="mb-2 w-full">
            <label for="Location">Location</label>
            <select-2
              autocomplete
              class="w-full"
              ref="locationList"
              v-model="form.locationId"
              @input="(item) => (form.locationId = item && item.value)"
              name="Location"
              placeholder="Select Location"
              newLabel="Add New Location"
              @addNew="toggleAddLocationModal"
              label="name"
              :ssr="true"
              :params="{ dropdownLocationId: form.locationId }"
              action="location/fetchLocations"
            />
          </div>

          <!-- growth date -->
          <div class="mb-2 w-full">
            <label for="GrowthDate">Growth Date</label>
            <date-picker
              :appendToBody="false"
              v-model="form.growth_date"
              placeholder="MM-DD-YYYY"
              format="MM-DD-YYYY"
              valueType="format"
              class="w-full"
              label="Growth Date"
              name="Growth Date"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('Growth Date')">{{ errors.first('Growth Date') }}</span>
          </div>
        </div>
      </div>

      <hr class="mb-5" />

      <div class="vx-row">
        <div class="mb-3 vx-col w-full grid xl:grid-cols-5 md:grid-cols-1 gap-x-5 items-end">
          <!-- Batch Name-->
          <div class="mb-2 w-full">
            <label for="GrowthPhase">Batch Name</label>
            <select-2
              autocomplete
              class="w-full"
              v-model="filters.batchId"
              @input="
                (item) => {
                  filters.batchId = item && item.value
                }
              "
              name="Batch Name"
              placeholder="Select Batch Name"
              :clearable="false"
              :options="batchOptions"
            />
          </div>

          <!-- Plant name -->
          <div class="mb-2 w-full">
            <label for="plantName">Plant Name</label>
            <select-2
              autocomplete
              class="w-full"
              v-model="filters.plant_name"
              @input="(item) => (filters.plant_name = item && item.value)"
              name="Plant Name"
              placeholder="Select Plant Name"
              :ssr="true"
              :options="plantNameOptions"
            />
          </div>

          <!-- serial number is Range -->
          <div class="mb-2 w-full">
            <label for="GrowthPhase">Serial Number Range</label>
            <select-2
              autocomplete
              class="w-full"
              v-model="filters.serialNumberStart"
              @input="
                (item) => {
                  filters.serialNumberStart = item && item.value
                }
              "
              name="Batch Name"
              label="serialNumber"
              val="serialNumber"
              placeholder="Start"
              :clearable="false"
              :options="plantList"
            />
          </div>

          <!-- serial number is Range -->
          <div class="mb-2 w-full">
            <label for="GrowthPhase">Serial Number Range</label>
            <select-2
              autocomplete
              class="w-full"
              v-model="filters.serialNumberEnd"
              @input="
                (item) => {
                  filters.serialNumberEnd = item && item.value
                }
              "
              name="Batch Name"
              label="serialNumber"
              val="serialNumber"
              placeholder="End"
              :clearable="false"
              :options="plantList"
            />
          </div>

          <!-- Clear Filters-->
          <div class="mb-2 w-full">
            <vs-button class="mr-2 clear-filt-btn" color="danger" type="relief" @click="clearFilter">Clear Filters</vs-button>
          </div>
        </div>
      </div>

      <hr class="mb-5" />

      <div class="plant_tag__list vx-row">
        <div class="vx-col w-full">
          <!-- number of plant selected -->
          <div class="num__selected_plants text-center mb-5">{{ selectedPlants.length }} Plants Selected</div>
          <!-- plant list -->
          <vs-table v-model="selectedPlants" multiple id="plant_list_table" class="vs-con-loading__container mb-5" stripe :data="plantListOptions" :total="plantListOptions.length">
            <template slot="thead">
              <vs-th>Plant Name</vs-th>
              <vs-th>Serial Number</vs-th>
              <vs-th>Growth Phase</vs-th>
              <!-- <vs-th>Plant Tag</vs-th> -->
            </template>

            <template slot-scope="{ data }" ref="tableBody">
              <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
                <vs-td>
                  {{ tr.plant_name }}
                </vs-td>

                <vs-td>
                  {{ tr.serialNumber }}
                </vs-td>

                <!-- plant stage -->
                <vs-td>{{ renderPlantStage(tr.plant_stage) || 'Immature' }}</vs-td>

                <!-- plant tag -->
                <!-- <vs-td>{{ tr.tag_no }}</vs-td> -->
              </vs-tr>

              <vs-tr v-if="processing">
                <vs-td>
                  <div class="flex justify-center">
                    Loading
                    <div class="spinner_circle ml-5"></div>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <!-- <div class="vx-col w-1/2"> -->
        <!-- <div v-if="!this.tagProcessing && !metrcTags.length" class="text-center mb-5">
            <b>you have no tags, please click here to generate tags</b>
            <vs-button @click="redirectToSeedsuiteTag" class="ml-5" color="primary" type="relief">List tags</vs-button>
          </div> -->
        <!-- list of tag numbers -->
        <!-- number of tag selected -->
        <!-- <div class="num__selected_tags text-center mb-5">{{ selected.length }} Tags Selected</div> -->

        <!-- tag no -->
        <!-- <vs-table v-model="selected" multiple id="tag_list__table" class="vs-con-loading__container mb-5" stripe :data="[...metrcTags]" :total="metrcTags.length">
            <template slot="thead">
              <vs-th>Tag No.</vs-th>
            </template>

            <template slot-scope="{ data }" ref="tableBody">
              <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
                <vs-td>
                  {{ `${tr.tag_no}` }}
                </vs-td>
              </vs-tr>

              <vs-tr v-if="tagProcessing">
                <vs-td>
                  <div class="flex justify-center">
                    Loading
                    <div class="spinner_circle ml-5"></div>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table> -->
        <!-- </div> -->
      </div>

      <!-- action btn -->
      <div class="vx-row justify-center">
        <vs-button class="mr-5" @click="changeGrowthPhaseValidation" color="primary" type="relief">Save</vs-button>
        <vs-button class="mr-2" color="danger" type="relief" @click="isActive = false">Cancel</vs-button>
      </div>
    </vs-popup>

    <!-- add location modal -->
    <add-location-modal v-if="isAddLocationModalMounted" :showModal.sync="isAddLocationModalShow" @updateList="updateLocationList" />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Select2 from '../../../../../components/custom/form-elements/Select2.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'
import AddLocationModal from '@/views/location/AddLocation'
import { infiniteScrollMixin, backgrondScrollHandler } from '@/utils/functions'
import { validateMixins } from '@/mixins/validate'
import { plantStages } from '@/utils/batch-options'

export default {
  name: 'ChangeGrowthPhase',

  props: {
    isModalShow: Boolean,
    batchId: {
      type: Number,
      default: null
    },
    plantStages: Array
  },

  components: {
    Select2,
    DatePicker,
    AddLocationModal
  },

  data() {
    return {
      zIndex: 0,

      // add new location modal mounted
      isAddLocationModalMounted: false,
      isAddLocationModalShow: false,
      addLocationModalStat: false,
      metrcTags: [],
      tagSelectAction: 0,

      totalMetrcTags: 0,
      processing: false,
      tagProcessing: false,
      loading: false,
      page: 1,
      limit: 0,
      search: null,
      order: null,
      type: 'MedicalPlant',
      status: 'not used',

      form: {
        plant_stage: null,
        locationId: null,
        growth_date: moment().format('MM-DD-YYYY')
      },
      selected: [],
      date: 'MM-dd-yyyy',

      // growth phase option
      growthPhaseOptions: plantStages.reduce((acc, item) => {
        if (item.value !== 'destroyed') {
          acc.push(item)
        }
        return acc
      }, []),

      // filters
      filters: {
        batchId: null,
        plant_name: null,
        serialNumberStart: null,
        serialNumberEnd: null
      },

      // plants
      selectedPlants: [],
      totalPlants: 0,
      plantPage: 1,
      plantLimit: 0,
      plantList: [],

      // batch
      batchOptions: [],
      batchFilters: {
        page: 1,
        length: 0,
        order: [],
        search: null
      }
    }
  },

  mixins: [infiniteScrollMixin, validateMixins],

  mounted() {
    // set modal zindex
    this.SET_MODAL_ZINDEX(true)

    // set z index
    this.zIndex = this.modal.modalZIndex + this.modal.modalOpens + 1

    if (this.batchId) this.filters.batchId = this.batchId

    // handle backgrond scroll
    backgrondScrollHandler(true)

    // get batch list
    this.getBatchList()
    // fetch plant tag list
    // this.findPlantTag()
  },

  computed: {
    ...mapState(['modal']),
    ...mapState('auth', ['user']),

    isActive: {
      get() {
        return this.isModalShow
      },
      set(val) {
        // handle backgrond scroll
        backgrondScrollHandler(false)
        this.$emit('update:isModalShow', val)
      }
    },

    plantNameOptions() {
      return [...new Set(this.plantList.map((item) => item.plant_name))].map((x) => {
        return {
          label: x,
          value: x
        }
      })
    },

    plantListOptions() {
      return this.plantList
        .filter((x) => {
          return this.filters.plant_name ? x.plant_name === this.filters.plant_name : true
        })
        .filter((x) => {
          if (!this.filters.serialNumberStart && !this.filters.serialNumberEnd) return true

          if (this.filters.serialNumberStart && this.filters.serialNumberEnd && this.filters.serialNumberStart > this.filters.serialNumberEnd) {
            return x.serialNumber <= this.filters.serialNumberStart && x.serialNumber >= this.filters.serialNumberEnd
          }

          if (this.filters.serialNumberStart && !this.filters.serialNumberEnd) {
            return x.serialNumber >= this.filters.serialNumberStart
          }

          if (!this.filters.serialNumberStart && this.filters.serialNumberEnd) {
            return x.serialNumber <= this.filters.serialNumberEnd
          }

          return x.serialNumber >= this.filters.serialNumberStart && x.serialNumber <= this.filters.serialNumberEnd
        })
    },

    renderPlantStage() {
      return (plantStage) => {
        return (plantStages.find((x) => x.value === plantStage) || {}).label
      }
    }
  },

  methods: {
    ...mapMutations(['SET_MODAL_ZINDEX']),
    ...mapActions('setting', ['getTags']),
    ...mapActions('batch', ['assignMetrcPlantTag']),

    async getBatchList(page = this.batchFilters.page) {
      this.$store
        .dispatch('batch/getBatches', { page, limit: this.batchFilters.length, search: this.batchFilters.search, order: this.batchFilters.order })
        .then(({ data }) => {
          this.batchOptions.push(
            ...data.reduce((acc, item) => {
              item.label = `${item.batch_number} - ${item.batch_name}`
              acc.push(item)

              return acc
            }, [])
          )
        })
        .catch(({ message }) => {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    async findPlantTag() {
      this.tagProcessing = true
      const { page, limit, search, order, status } = this

      this.$store
        .dispatch('tags/getTagList', { page, limit, search, order, tag_type: this.type, status })
        .then(({ data, total }) => {
          this.totalMetrcTags = total
          this.metrcTags.push(
            ...data.map((ele, i) => {
              return {
                id: i,
                ...ele
              }
            })
          )
        })
        .finally(() => {
          this.tagProcessing = false
        })
    },

    async changeGrowthPhaseValidation() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Fill The Form First',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }

      if (this.selectedPlants.length > this.selected.length) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Are you sure?',
          text: 'Are you sure you want to save this record?',
          acceptText: 'Yes, I am sure!',
          cancelText: 'No, cancel it!',
          accept: () => this.changeGrowthPhase()
        })
      } else {
        this.changeGrowthPhase()
      }
    },

    async changeGrowthPhase() {
      this.loading = true

      // list of selected tags
      const tagNumbers = this.selected.reduce((acc, item) => {
        acc.push(item.tag_no)
        return acc
      }, [])

      // list of selected plants
      const plantIds = this.selectedPlants.reduce((acc, item) => {
        acc.push(item.id)
        return acc
      }, [])

      try {
        const { message } = await this.assignMetrcPlantTag({
          ...this.form,
          tagNumbers,
          plantIds,
          is_immature_plant: false
        })

        this.loading = false

        this.$emit('update:isAssignPlantTagModal', false)
        this.$emit('done')

        this.isActive = false

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch ({ message }) {
        this.loading = false

        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    updateLocationList(data) {
      this.form.locationId = data.id

      this.$nextTick(() => {
        this.$refs.locationList.getOptions()
      })
    },

    // handle plant select
    handlePlantselect() {
      const selectedTagIds = this.selected.map((e) => e.id)
      const selectedPlantsIds = this.selectedPlants.filter((x) => !x.tag_no).map((e) => e.id)

      if (selectedPlantsIds.length !== this.selected.length) {
        this.tagSelectAction = !this.tagSelectAction
        if (selectedPlantsIds.length > this.selected.length) {
          for (let i = 0; i < this.metrcTags.length; i++) {
            if (!selectedTagIds.includes(this.metrcTags[i].id)) {
              this.selected.push(this.metrcTags[i])

              break
            }
          }
        } else {
          this.selected = []
        }

        if (this.selected.length !== this.metrcTags.length) {
          this.handlePlantselect()
        }
      }
    },

    // get batch plant list
    getBatchPlants() {
      this.processing = true
      const { plantPage, plantLimit, plantOrder, plantSearch } = this
      this.$store
        .dispatch('batch/getBatchPlants', {
          id: this.filters.batchId,
          list: 'plant',
          data: {
            page: plantPage,
            limit: plantLimit,
            order: plantOrder,
            search: plantSearch,
            plantStages: ['seedling', 'pre_veg', 'veg', 'flower', 'drying', 'dried', 'mother', 'male']
          }
        })
        .then((res) => {
          this.totalPlants = res.FilteredCount
          this.plantList.push(...res.data.filter((x) => !x.product_plants.length))

          // default location id
          this.form.locationId = res.data[0].batch.locationId
        })
        .finally(() => {
          this.processing = false
        })
    },

    // clear filter
    clearFilter() {
      // clear filters
      this.filters.plant_name = null
      this.filters.batchId = this.batchId
      this.filters.serialNumberStart = null
      this.filters.serialNumberEnd = null

      // clear forms
      this.form = {
        plant_stage: null,
        locationId: null,
        growth_date: null
      }

      // clear plants
      this.selectedPlants = []
      this.selected = []

      // reset form
      this.resetForm()
    },

    //redirect the seedsuite tag module
    redirectToSeedsuiteTag() {
      this.isActive = false
      this.$router.push({ name: 'seedsuite-tags' })
    },

    toggleAddLocationModal() {
      this.isAddLocationModalMounted = true
      this.isAddLocationModalShow = true
    },

    handleSelectAllTags() {
      const selectedPlantsCount = this.plantList.filter((x) => !x.tag_no).length
      if (this.selected.length > 0 && this.selected.length > selectedPlantsCount) {
        this.tagSelectAction = !this.tagSelectAction
        if (this.tagSelectAction) {
          this.selected.splice(selectedPlantsCount, this.selected.length - selectedPlantsCount)
        } else {
          this.selected = []
        }
      }
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#growthPhaseChangePopup .vs-popup .vs-popup--content',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#growthPhaseChangePopup .vs-popup .vs-popup--content > .con-vs-loading')
      }
    },

    selectedPlants: {
      deep: true,
      handler() {
        this.handlePlantselect()
      }
    },

    'filters.batchId': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.plantList = []
          this.plantPage = 1
          this.getBatchPlants()
        }
      }
    },

    isAddLocationModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAddLocationModalMounted = false
          }, 0)
        }
      }
    },

    selected: {
      immediate: true,
      handler() {
        this.handleSelectAllTags()
      }
    }
  }
}
</script>

<style lang="scss">
#growthPhaseChangePopup {
  .vs-popup {
    width: calc(100% - 30%) !important;
    position: relative;

    .vs-popup--content {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .con-vs-loading {
      position: absolute;
    }

    .vs-con-table .vs-con-tbody {
      overflow: hidden;
    }

    .vs-table--content {
      overflow: auto;
      min-width: 700px;
    }
  }
  .plant_tag__list {
    flex-grow: 1;
  }

  #tag_list__table,
  #plant_list_table {
    min-height: 200px;
    height: calc(100vh - 516px);
    overflow-y: auto;
    overflow-x: auto;
  }
  .clear-filt-btn {
    padding: 10px;
  }
  .spinner_circle {
    width: 20px;
    height: 20px;
    background-color: #006622;
    border-radius: 50%;
    animation: animate 1s infinite;
    transition: 0.5s;

    @keyframes animate {
      0% {
        opacity: 0.1;
        transform: scale(0.2);
      }
      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
}

.table-loader {
  height: 40.98px;
  .con-vs-checkbox {
    display: none;
  }
}
</style>
